/**
 *
 * CustomDatePicker
 *
 */
import React from 'react';
import { InlineDatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import styled from 'styled-components';

import MomentUtils from '@date-io/moment';
import PropTypes from 'prop-types';

const DatePicker = styled(InlineDatePicker)`
  &&& {
    width: 100%;

    & > div {
      padding-left: 10px;
      background-color: white;
    }

    label {
      white-space: nowrap;
      text-transform: uppercase;
      font-weight: bold;
      color: #33383e;
      margin-left: 10px;
      letter-spacing: 2px;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CustomDatePickerYM extends React.Component {
  render() {
    const { onChange, selectedDate, label, minDate,format, view, maxDate } = this.props;
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <DatePicker
          InputProps={{
            disableUnderline: true,
            style: { border: '1px solid #FAB028' }
          }}
          valueDefault={null}
          value={selectedDate}
          onChange={onChange}
          openTo="year"
          views={[view]}   // ['year']
          label={label}
          InputLabelProps={{
            shrink: true,
          }}
          minDate={minDate}
          maxDate={maxDate}
          format={format}  // 'YYYY'
        />
      </MuiPickersUtilsProvider>
    );
  }
}

CustomDatePickerYM.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedDate: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  minDate: PropTypes.any,
};

export default CustomDatePickerYM;



// WEBPACK FOOTER //
// ./src/components/CustomDatePickerYM.js